// Left untruncated so stringToColor keeps producing the exact colours it always has
const hashCode = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};

/** Stable slot in [0, size) for a string, so the same input always maps alike. */
export const stringToIndex = (str: string, size: number) =>
  Math.abs(hashCode(str) | 0) % size;
